export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12901.689af0c5.jpg";